import { gql } from '@apollo/client';

/* ============================
   GET OTHER ITEM
============================ */

export const GET_OTHER_ITEMS = gql`
  query GetOtherItems($input: GetOtherItemsInput) {
    getOtherItems(input: $input) {
      results {
        _id
        name
        price
        units
        status
        categoryId
        description
        isLimitedUnits
        visibility
      }
      totalCount
    }
  }
`;

/* ============================
   CREATE OTHER ITEM
============================ */

export const CREATE_OTHER_ITEM = gql`
  mutation CreateOtherItem($input: CreateOtherItemInput!) {
    createOtherItem(input: $input) {
      success
      message
      otherItem {
        _id
      }
    }
  }
`;

/* ============================
   UPDATE OTHER ITEM
============================ */

export const UPDATE_OTHER_ITEM = gql`
  mutation UpdateOtherItem($input: UpdateOtherItemInput!) {
    updateOtherItem(input: $input) {
      success
      message
      otherItem {
        _id
      }
    }
  }
`;

/* ============================
   CHANGE OTHER ITEM STATUS
============================ */

export const CHANGE_OTHER_ITEM_STATUS = gql`
  mutation ChangeOtherItemStatus($input: ChangeOtherItemStatusInput!) {
    changeOtherItemStatus(input: $input) {
      success
      message
    }
  }
`;
